import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { isStaff } from './permissions';
import { loginRequest, logoutRequest, fetchMe } from './session';
import { useAuthStore } from './store';

export function useAuth() {
  const queryClient = useQueryClient();
  const { user, status, has, setUser, reset } = useAuthStore();

  const login = useCallback(
    async (email: string, password: string) => {
      await loginRequest(email, password);
      const me = await fetchMe();
      setUser(me);
      return me;
    },
    [setUser],
  );

  const logout = useCallback(async () => {
    await logoutRequest();
    reset();
    queryClient.clear();
  }, [reset, queryClient]);

  return {
    user,
    status,
    isAuthenticated: status === 'authenticated',
    isStaff: user ? isStaff(user.roles ?? []) : false,
    has,
    login,
    logout,
  };
}
